import { create } from 'zustand'
import { ConfirmModalState, GenericModalState, GlobalState } from './global.type'

export const createModalStore = () =>
  create<GenericModalState>((set) => ({
    isOpen: false,
    setIsOpen: (isOpen) => set({ isOpen }),
  }))

export const useGlobalState = create<GlobalState>()((set) => ({
  appLoading: true,
  setAppLoading: (loading) => set({ appLoading: loading }),

  showNavBar: false,
  setShowNavBar: (showNavBar) => set(() => ({ showNavBar })),

  workspaceMembers: null,
  setWorkspaceMembers: (members) => set({ workspaceMembers: members }),

  workspaceIssues: null,
  setWorkspaceIssues: (issues) => set({ workspaceIssues: issues }),
}))

export const useConfirmModalState = create<ConfirmModalState>()((set) => ({
  open: false,
  submitBtnVariant: 'danger',
  setModalState: (data) => set(() => data),
  resetModalState: () =>
    set(() => ({
      open: false,
    })),
}))
